"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AssignmentWithApi = void 0;
var React = _interopRequireWildcard(require("react"));
var _react2 = require("@fluentui/react");
var _OwnerType = require("../../../Shared/Models/OwnerType");
var _ReadonlyAssignedServices = _interopRequireDefault(require("./ReadonlyAssignedServices"));
var _ReadonlyDirectOwners = _interopRequireDefault(require("./ReadonlyDirectOwners"));
var _EditableAssignmentChoiceGroup = _interopRequireDefault(require("./EditableAssignmentChoiceGroup"));
var _LoadingShimmer = _interopRequireDefault(require("../../../Shared/Components/LoadingShimmer"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var AssignmentWithApi = function AssignmentWithApi(props) {
  return /*#__PURE__*/React.createElement(_react2.Stack, {
    tokens: {
      childrenGap: 8
    }
  }, props.error && /*#__PURE__*/React.createElement(_react2.MessageBar, {
    messageBarType: _react2.MessageBarType.error
  }, props.error.message), !props.isReadonly ? /*#__PURE__*/React.createElement(_EditableAssignmentChoiceGroup.default, {
    isLoading: props.isLoading,
    ownerType: props.ownerType,
    ownerPickerProps: props.ownerPickerProps,
    isReadonly: props.isSubmitting,
    setOwnerType: props.setOwnerType,
    serviceTreePickerProps: props.serviceTreePickerProps
  }) : /*#__PURE__*/React.createElement("div", {
    style: {
      paddingBottom: "16px"
    }
  }, props.ownerType === _OwnerType.OwnerType.SERVICE && /*#__PURE__*/React.createElement(_ReadonlyAssignedServices.default, {
    defaultProducts: props.serviceTreePickerProps.defaultProducts
  }), props.ownerType === _OwnerType.OwnerType.PERSON && /*#__PURE__*/React.createElement(_ReadonlyDirectOwners.default, {
    artifactOwnership: props.ownerPickerProps.defaultArtifactOwnership
  })));
};
exports.AssignmentWithApi = AssignmentWithApi;
var AssignmentSection = function AssignmentSection(props) {
  if (props.isLoading) {
    return /*#__PURE__*/React.createElement(_LoadingShimmer.default, null);
  } else {
    return /*#__PURE__*/React.createElement(AssignmentWithApi, props);
  }
};
var _default = AssignmentSection;
exports.default = _default;